module.exports = __webpack_public_path__ + "img/gold_level3.73751cc8.png";